<template>
 <svg :style="style"   width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Mask group">
<mask id="mask0_3735_78483" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<rect id="Rectangle 34624917" width="32" height="32" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_3735_78483)">
</g>
<g id="Frame">
<path id="Vector" d="M23.8491 10.6057C22.0484 10.6057 20.5837 9.14097 20.5837 7.34034C20.5837 5.54097 22.0484 4.0769 23.8491 4.0769C25.6503 4.0769 27.1156 5.54097 27.1156 7.34034C27.1156 9.14097 25.6503 10.6057 23.8491 10.6057ZM29.4819 12.8463L26.2219 16.4172C25.9194 16.7484 25.5081 16.9601 25.0628 17.0138C24.989 17.0223 24.9147 17.0267 24.8403 17.0269C24.4682 17.0269 24.1046 16.9159 23.7959 16.7082L21.3616 15.0744L19.0091 17.1657L22.605 18.9157C23.0797 19.1469 23.4359 19.5703 23.5825 20.0772C23.7291 20.5835 23.6544 21.1313 23.3769 21.5797L20.0319 26.9941C19.7694 27.4191 19.3569 27.7163 18.8703 27.8316C18.7281 27.8653 18.5824 27.8824 18.4363 27.8825C18.0931 27.8825 17.7559 27.7875 17.4569 27.6022C16.5787 27.0607 16.3059 25.9063 16.8478 25.0291L19.1066 21.3738L16.3475 20.0303L14.1141 23.4722C13.9532 23.7196 13.7366 23.9257 13.4816 24.0741L7.73031 27.6135C7.44219 27.7803 7.12219 27.8657 6.79719 27.8657C6.63469 27.8657 6.47188 27.8441 6.31063 27.801C5.8275 27.6719 5.42344 27.3622 5.17406 26.9294C4.65813 26.0369 4.96531 24.8913 5.85813 24.3753L11.2188 21.0603L13.8756 17.0775L13.9019 17.035C14.0053 16.7239 14.1888 16.4455 14.4341 16.2278L18.1413 12.9319L16.4781 11.83L12.9934 12.8266C11.9994 13.1063 10.9625 12.53 10.6797 11.5441C10.3963 10.5528 10.9725 9.51503 11.9625 9.23097L16.2787 7.99815C16.5386 7.92359 16.8116 7.90629 17.0788 7.94746C17.3461 7.98862 17.6012 8.08727 17.8266 8.23659L22.235 11.1569C22.2906 11.1935 22.3431 11.2335 22.3934 11.2753V11.2735L24.5444 12.7072L26.7181 10.326C27.0547 9.95659 27.5156 9.74128 28.0153 9.71847C28.5144 9.69565 28.9928 9.86909 29.3622 10.2063C30.1234 10.8997 30.1778 12.0847 29.4819 12.8463ZM10.2709 7.72097H3.76781C3.45625 7.72097 3.20219 7.46378 3.20219 7.1494C3.20219 6.83503 3.45625 6.57784 3.76781 6.57784H10.2709C10.5819 6.57784 10.8366 6.83503 10.8366 7.1494C10.8366 7.46347 10.5819 7.72097 10.2709 7.72097ZM10.2144 15.5838H2.56562C2.25469 15.5838 2 15.3266 2 15.0122C2 14.6978 2.25469 14.4407 2.56562 14.4407H10.2144C10.5253 14.4407 10.7794 14.6978 10.7794 15.0122C10.7797 15.3266 10.5256 15.5838 10.2144 15.5838ZM6.93406 11.55H4.61562C4.30469 11.55 4.05 11.2928 4.05 10.9785C4.05 10.6641 4.30469 10.4069 4.61562 10.4069H6.93406C7.245 10.4069 7.49969 10.6641 7.49969 10.9785C7.5 11.2925 7.24531 11.55 6.93406 11.55Z" fill="white"/>
</g>
</g>
</svg>





</template>

<script>
export default {
  name: 'icon-hyzbjb',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>